/**
 * @generated SignedSource<<5e9025b6b9c1ae69dd3c8c65f3997918>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotosSearchBrowseWrapper_viewer$data = {
  readonly photosSearchBrowseQuery: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly designFirm: {
          readonly name: string | null;
        } | null;
        readonly name: string | null;
        readonly room: {
          readonly name: string | null;
        } | null;
        readonly url: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowsePhotoPreviewModal_photo">;
      } | null;
    } | null> | null;
    readonly facets: {
      readonly designProjectTypeFacet: ReadonlyArray<{
        readonly label: string | null;
        readonly name: string | null;
      } | null> | null;
      readonly imageCreatorFacets: ReadonlyArray<{
        readonly label: string | null;
        readonly name: string | null;
      } | null> | null;
      readonly imageRoomTypeFacet: ReadonlyArray<{
        readonly label: string | null;
        readonly name: string | null;
      } | null> | null;
      readonly imageStyleFacet: ReadonlyArray<{
        readonly label: string | null;
        readonly name: string | null;
      } | null> | null;
    } | null;
    readonly numberOfPages: number | null;
    readonly totalResults: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseContent_photos" | "PhotosSearchBrowseFacetFilterModal_photos" | "PhotosSearchBrowseFacetFilter_photos" | "PhotosSearchBrowsePhotoPreviewModal_photos" | "PhotosSearchBrowseRelatedDesignsContainer_photos">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseFacetFilterModal_viewer" | "PhotosSearchBrowseFacetFilter_viewer">;
  readonly " $fragmentType": "PhotosSearchBrowseWrapper_viewer";
};
export type PhotosSearchBrowseWrapper_viewer$key = {
  readonly " $data"?: PhotosSearchBrowseWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseWrapper_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "label",
    "storageKey": null
  },
  (v0/*: any*/)
],
v2 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "creator"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "page"
    },
    {
      "kind": "RootArgument",
      "name": "project"
    },
    {
      "kind": "RootArgument",
      "name": "room"
    },
    {
      "kind": "RootArgument",
      "name": "searchTerm"
    },
    {
      "kind": "RootArgument",
      "name": "style"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotosSearchBrowseWrapper_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PhotosSearchBrowseFacetFilterModal_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PhotosSearchBrowseFacetFilter_viewer"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "creator",
          "variableName": "creator"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page"
        },
        {
          "kind": "Variable",
          "name": "project",
          "variableName": "project"
        },
        {
          "kind": "Variable",
          "name": "room",
          "variableName": "room"
        },
        {
          "kind": "Variable",
          "name": "searchTerm",
          "variableName": "searchTerm"
        },
        {
          "kind": "Variable",
          "name": "style",
          "variableName": "style"
        }
      ],
      "concreteType": "PhotosSearchBrowseQueryConnection",
      "kind": "LinkedField",
      "name": "photosSearchBrowseQuery",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PhotosSearchBrowseFacetFilterModal_photos"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PhotosSearchBrowseFacetFilter_photos"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PhotosSearchBrowseContent_photos"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PhotosSearchBrowsePhotoPreviewModal_photos"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PhotosSearchBrowseRelatedDesignsContainer_photos"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PhotosSearchBrowseFacets",
          "kind": "LinkedField",
          "name": "facets",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FacetValueType",
              "kind": "LinkedField",
              "name": "imageStyleFacet",
              "plural": true,
              "selections": (v1/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FacetValueType",
              "kind": "LinkedField",
              "name": "imageRoomTypeFacet",
              "plural": true,
              "selections": (v1/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FacetValueType",
              "kind": "LinkedField",
              "name": "designProjectTypeFacet",
              "plural": true,
              "selections": (v1/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FacetValueType",
              "kind": "LinkedField",
              "name": "imageCreatorFacets",
              "plural": true,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PhotosSearchBrowseQueryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PhotosSearchBrowsePhoto",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PhotosSearchBrowsePhotoPreviewModal_photo"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TradePhotoStyle",
                  "kind": "LinkedField",
                  "name": "room",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "DesignFirm",
                  "kind": "LinkedField",
                  "name": "designFirm",
                  "plural": false,
                  "selections": (v2/*: any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalResults",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "numberOfPages",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "3d6b4f28f64389dbf09ae68107795401";

export default node;
